module.exports = __webpack_public_path__ + "static/media/Sunny_Grateful.2de0e7fc.gif";